import { render } from "./CartLineReturnsTab.vue?vue&type=template&id=54250d86"
import script from "./CartLineReturnsTab.vue?vue&type=script&lang=js"
export * from "./CartLineReturnsTab.vue?vue&type=script&lang=js"

import "./CartLineReturnsTab.vue?vue&type=style&index=0&id=54250d86&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__